import React from 'react';
import {BaseMixin, ElementaryMixin, NestingLevelMixin, ContentMixin} from '../common/common.js';
import Environment from '../environment/environment.js';

import './blockquote-footer.less';

export default React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    NestingLevelMixin,
    ContentMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Blockquote.footer',
    nestingLevelList: Environment.getNestingLevelList('bigBoxCollection', 'box'),
    classNames: {
      main: 'uu5-bricks-blockquote-footer',
      right: 'uu5-bricks-blockquote-footer-right',
      left: 'uu5-bricks-blockquote-footer-left'
    },
    opt: {
      nestingLevelWrapper: true
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    alignment: React.PropTypes.oneOf([
      'left',
      'right'
    ])
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      alignment: 'left'
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _buildMainAttrs: function () {
    var mainAttrs = this.buildMainAttrs();
    this.props.alignment === 'right' && (mainAttrs.className += ' ' + this.getClassName().right);
    this.props.alignment === 'left' && (mainAttrs.className += ' ' + this.getClassName().left);
    return mainAttrs;
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return (
      this.getNestingLevel()
        ? (
        <footer {...this._buildMainAttrs()}>
          {this.getChildren()}
        </footer>
        ) : null
    );
  }
  //@@viewOff:render
});



// WEBPACK FOOTER //
// ./bricks/blockquote-footer.js